module.exports = __webpack_public_path__ + "img/Diwali.4255e2da.jpeg";